const sns = [
  {
    ttl: "유튜브",
    desc: "실제 사례와 보상 노하우를 영상으로 확인하세요",
    icon: "ri-youtube-fill",
    color: "bg-[#FF0000]",
    href: "https://youtube.com/channel/UCenpa2i5gzClXmelYa0pizA?si=LKDV0AHLfgZpQeXg",
  },
  {
    ttl: "인스타그램",
    desc: "일상적인 상담 이야기와 최신 정보를 만나보세요",
    icon: "ri-instagram-line",
    color: "bg-[#E1306C]",
    href: "https://www.instagram.com/dada.sonsa/",
  },
  {
    ttl: "네이버 블로그",
    desc: "판례·약관 해석 등 심층 콘텐츠를 확인하세요",
    icon: "ri-quill-pen-fill",
    color: "bg-[#2DB400]",
    href: "https://blog.naver.com/sonsabosang",
  },
];

export default function SnsLinks() {
  return (
    <section id="contact" className="relative py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20professional%20corporate%20workspace%20with%20soft%20moody%20lighting%2C%20laptop%20and%20coffee%20cup%20on%20wooden%20desk%2C%20blurred%20bookshelf%20in%20dark%20burgundy%20background%2C%20editorial%20lifestyle%20photography%2C%20cinematic%20dark%20atmosphere%2C%20refined%20cream%20and%20deep%20wine%20red%20tones&width=1800&height=900&seq=dada-sns-bg-01&orientation=landscape"
        alt="dark workspace"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/78"></div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="text-primary-400 text-xs tracking-[0.32em] font-semibold mb-4">
              OUR CHANNELS
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-background-50 leading-tight">
              <span className="block">편한 채널로</span>
              <span className="block">
                <span className="text-primary-400">다다손해사정</span>
                <span>과</span>
              </span>
              <span className="block">연결되세요</span>
            </h2>
            <p className="mt-6 text-background-200 leading-relaxed">
              공식 대표번호 이외에도 유튜브 · 인스타그램 · 블로그 등
              다양한 채널을 통해 소통하고 있습니다. 언제 어디서든 편하게 문의해 주세요.
            </p>
            <div className="mt-8 inline-flex items-center gap-3 bg-background-50/10 backdrop-blur border border-background-50/20 rounded-full px-5 py-3">
              <i className="ri-time-line text-primary-300"></i>
              <span className="text-background-100 text-sm">
                평일 09:00 ~ 18:00&nbsp;
              </span>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {sns.map((s) => (
              <a
                key={s.ttl}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative bg-background-50/8 hover:bg-background-50/15 backdrop-blur border border-background-50/15 rounded-lg p-6 transition cursor-pointer overflow-hidden"
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`w-14 h-14 flex items-center justify-center rounded-full ${s.color} text-background-50`}
                  >
                    <i className={`${s.icon} text-2xl`}></i>
                  </span>
                  <i className="ri-arrow-right-up-line text-background-100 text-2xl group-hover:text-primary-300 group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform"></i>
                </div>
                <div className="mt-5">
                  <div className="font-heading font-bold text-xl text-background-50">
                    {s.ttl}
                  </div>
                  <div className="text-sm text-background-200 mt-1">{s.desc}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}